import { ExtratoDeRecebimentos } from '../../../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { ChartUltimos10DiasOptions } from './chart-ultimos-10-dias-options'

export class ChartUltimosRecebimentosOptions extends ChartUltimos10DiasOptions {
    constructor(extrato: ExtratoDeRecebimentos) {
        super(extrato, 'Quanto recebi nos últimos 10 dias')

        this.yAxis.title.text = 'Recebimentos em reais'
    }

    obterSeries(): { name: string; data: number[] }[] {
        if (!this.extrato) {
            return []
        }

        return this.extrato.agrupamentos.map(agrupamento => {
            return {
                name: agrupamento.operadora.nome,
                data: this.datas.map(data => {
                    const detalhe = agrupamento.detalhes.find(
                        d => d.transacao.data.getTime() == data.getTime()
                    )

                    return detalhe ? detalhe.transacao.valorLiquido : null
                })
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/ultimos-10-dias/shared/chart-ultimos-recebimentos-options.ts